import React, { FC } from 'react';
import { useTheme } from '@mui/material';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { GridRowId, useGridApiContext } from '@mui/x-data-grid-pro';
import { useSelector } from 'react-redux';

import { IDepartmentDTO } from 'src/api/dtos';
import { ChevronDownIcon } from 'src/shared/components';
import { formatDepartmentDisplay } from 'src/shared/utils';
import { getEmployeeDepartmentDisplayFormat } from 'src/store/user/user.selectors';

interface Props {
  id: GridRowId;
  field: string;
  department: IDepartmentDTO | null;
  isEdited: boolean;
}

export const TimesheetDepartmentViewCell: FC<Props> = ({ id, field, department, isEdited }) => {
  const theme = useTheme();
  const apiRef = useGridApiContext();
  const employeeDepartmentDisplayFormat = useSelector(getEmployeeDepartmentDisplayFormat);

  const label = department
    ? formatDepartmentDisplay(department.description, department.number, employeeDepartmentDisplayFormat)
    : undefined;

  const handleCellClick = () => {
    apiRef.current.startCellEditMode({ id, field });
  };

  return (
    <Stack
      direction="row"
      width="100%"
      height="100%"
      justifyContent="center"
      alignItems="center"
      padding="0 8px"
      sx={{
        background: (theme) =>
          isEdited
            ? `${theme.palette.mode === 'dark' ? theme.palette.secondary.dark : theme.palette.secondary.main}`
            : 'initial',
      }}
      onClick={handleCellClick}
    >
      {label ? (
        <Typography fontSize="0.875rem" overflow="hidden" whiteSpace="nowrap" textOverflow="ellipsis" title={label}>
          {label}
        </Typography>
      ) : (
        <ChevronDownIcon color={theme.palette.text.secondary} style={{ marginLeft: 'auto' }} />
      )}
    </Stack>
  );
};
